<template>
  <div class="no-started-live">
    <!-- 直播带货脚本 -->
    <div class="live-script">
      <div class="container">
        <div class="head-box">
          <img class="decorate" src="@/assets/image/student/live/scriptLeftDecorate.png" />
          <div class="title">直播带货脚本</div>
          <img class="decorate" src="@/assets/image/student/live/scriptRightDecorate.png" />
        </div>
        <div class="content">
          <template v-if="scriptData.length > 0">
            <el-scrollbar style="height: 100%; flex: 1">
              <not-start-script :scriptData="scriptData"></not-start-script>
            </el-scrollbar>
          </template>
          <template v-else>
            <div class="empty">无脚本信息</div>
          </template>
          <!-- <div class="empty">无脚本信息</div> -->
        </div>
      </div>
    </div>

    <!-- 直播界面 -->
    <div class="live-main radius">
      <div class="container">
        <div class="head-user-info">
          <div class="left-user">
            <div class="user-box" tabindex="0">
              <img class="avatar" :src="getUserImg($route.query.avatar)" :alt="$route.query.nickname" :title="$route.query.nickname" />
              <div class="user-info-box">
                <div class="username">{{ $route.query.nickname }}</div>
              </div>
            </div>
          </div>

          <div class="right-audience">
            <div class="people-sum">{{ 0 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 直播相关信息 -->
    <div class="live-other-info">
      <div class="container">
        <div class="live-popularity popularity">
          <div class="time-box">
            <div class="item left-train-end-time">
              <div class="icon iconfont">&#xe603;</div>
              <div class="hint-box">
                <div class="hint">{{ "距离实训结束" }}</div>
                <div class="time">
                  <span>{{ trainTime[0] | getTimeStr }}:</span>
                  <span>{{ trainTime[1] | getTimeStr }}:</span>
                  <span>{{ trainTime[2] | getTimeStr }}</span>
                </div>
              </div>
            </div>
            <div class="item right-time-box">
              <div class="icon iconfont">&#xe602;</div>
              <div class="hint-box">
                <div class="hint">直播时长</div>
                <div class="not-start-time time">暂无</div>
              </div>
            </div>
          </div>
          <div class="popularity">
            <div class="icon iconfont">&#xe600;</div>
            <div class="right-popularity">
              <div class="hint">人气数据</div>
              <div class="info-list">
                <div class="item">
                  <div class="left">
                    <div class="label">实时在线人数</div>
                    <div class="num-box">0</div>
                  </div>
                  <div class="right">
                    <div class="label">成交件数</div>
                    <div class="num-box">0</div>
                  </div>
                </div>
                <div class="item">
                  <div class="left">
                    <div class="label">广告流量</div>
                    <div class="num-box">0</div>
                  </div>
                  <div class="right">
                    <div class="label">商品流量</div>
                    <div class="num-box">0</div>
                  </div>
                </div>
                <div class="item">
                  <div class="left">
                    <div class="label">直播流量</div>
                    <div class="num-box">0</div>
                  </div>
                  <div class="right">
                    <div class="label">点赞数</div>
                    <div class="num-box">0</div>
                  </div>
                </div>
                <div class="item">
                  <div class="left">
                    <div class="label">进入直播间人数</div>
                    <div class="num-box">
                      <div class="num">0</div>
                      <div class="rise iconfont">&#xe622;</div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="label">离开直播间人数</div>
                    <div class="num-box">
                      <div class="num">0</div>
                      <div class="go-down iconfont">&#xe630;</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bullet-chat">
          <div class="content">
            <el-scrollbar ref="scrollbar" style="height: 100%">
              <div class="title-box">
                <img class="decorate" src="~assets/image/student/live/scriptRightDecorate.png" />
                <div class="title">历史弹幕</div>
              </div>
              <div class="list">
                <div class="container"></div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { teacherGetScriptInfo } from "@/utils/apis.js";
import NotStartScript from "@/components/student/liveRoom/liveScript/NotStartScript";

export default {
  data() {
    return {
      trainTimer: void 0,
      trainTime: [0, 0, 0],
      scriptData: [],
    };
  },

  created() {
    this.setTrainCountDown();
    this.getScriptInfo();
  },

  filters: {
    getTimeStr(time) {
      return (time + "").length <= 1 ? `0${time}` : time;
    },
  },

  computed: {
    liveLongEnd() {
      return this.getTime(this.liveDuration);
    },
  },

  components: {
    NotStartScript,
  },

  methods: {
    // 获取头像，没有使用默认图片
    getUserImg(avatar) {
      return avatar ? avatar : require("assets/image/blank_headPic.png");
    },

    getTime(totalSecond) {
      const times = [];
      let hour = Math.floor(totalSecond / 60 / 60);
      let minute = Math.floor(totalSecond / 60) % 60;
      let second = totalSecond % 60;
      return [hour, minute, second];
    },

    setTrainCountDown() {
      this.trainTimer && clearInterval(this.trainTimer);

      this.trainTimer = setInterval(() => {
        let afterTime = this.$route.query.end_time;

        const diffSecond = Math.floor((+new Date(afterTime) - +new Date()) / 1000);
        this.trainTime = this.getTime(diffSecond);

        if (this.trainTime.every((item) => !item)) {
          clearInterval(this.trainTimer);
        }
      }, 1000);
    },

    getScriptInfo() {
      if (this.$route.query.room_id && this.$route.query.room_id != 0) {
        teacherGetScriptInfo({ room_id: this.$route.query.room_id }).then((res) => {
          if (res.code === 200) {
            const scriptList = res.data.new_script_data
              .filter((item) => ![2].includes(item.script_type))
              .map((item, index, arr) => {
                const getTime = () => {
                  const before = arr[index - 1];
                  return item.start_time == before.end_time ? item.start_time : before.end_time;
                };
                const haveDiffTime = index == 0 ? item.start_time : getTime();
                const common = {
                  ...item,
                  startTime: item.start_time,
                  endTime: item.end_time,
                  isChild: item.genre == 1 || item.genre == 2 ? item.genre : void 0,
                  sleepTime: item.end_time - haveDiffTime,
                };
                index == arr.length - 1 && this.$set(common, "end", 2);
                return common;
              });
            this.scriptData = scriptList;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.no-started-live {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  user-select: none;
  background-color: #070932;
  display: flex;
  padding: 20px;

  .live-script {
    box-sizing: border-box;
    flex: 6;
    font-size: 14px;
    color: #fff;
    background-color: #0c0e3f;

    .container {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      .head-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100px;
        width: 100%;
        font-size: 24px;
        .title {
          margin: 0 24px;
          margin-top: -2px;
        }
        .decorate {
          width: 41px;
          height: 15px;
          vertical-align: middle;
        }
      }
      .content {
        position: relative;
        flex: 1;
        display: flex;
        justify-content: center;
        overflow: hidden;
        .live-ing-script {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          width: 85%;
          height: 100%;
          font-size: 24px;
          line-height: 72px;
          letter-spacing: 1px;
          word-break: break-all;
          overflow: hidden;
          .text {
            transform: translateY(-30px);
          }
        }
        .empty {
          position: absolute;
          top: 40%;
          font-size: 20px;
          color: #aaa;
        }
      }
    }
  }

  .live-main {
    position: relative;
    box-sizing: border-box;
    width: 562px;
    height: 100%;
    margin: 0 20px;
    overflow: hidden;
    padding: 12px 10px;
    background: url("../../../assets/image/default-live-no-start-bg.png") no-repeat;
    background-size: cover;

    &.radius {
      border-radius: 20px;
    }

    .container {
      .head-user-info {
        display: flex;
        justify-content: space-between;
        width: 100%;
        color: #fff;

        .left-user {
          position: relative;
          box-sizing: border-box;
          width: calc(222px - 53px);
          outline: none;

          .user-box {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 48px;
            background-color: rgba(0, 0, 0, 0.3);
            border-radius: 24px;

            .avatar {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              cursor: pointer;
            }

            .user-info-box {
              flex: 1;
              margin-left: 5px;
              text-align: center;
              font-size: 15px;
              font-weight: 700;
              overflow: hidden;

              .username {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }

        .right-audience {
          display: flex;
          align-items: center;
          height: 48px;

          .people-sum {
            min-width: 60px;
            height: 36px;
            margin: 0 5px;
            line-height: 36px;
            text-align: center;
            background-color: #000;
            opacity: 0.3;
            border-radius: 18px;
          }
        }
      }
    }
  }

  .live-other-info {
    box-sizing: border-box;
    flex: 4;

    .container {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;

      .popularity {
        padding-block: 20px;
        margin-bottom: 20px;
        background-color: #0c0e3f;
      }

      .bullet-chat {
        flex: 1;
        background-color: #0c0e3f;
      }

      .live-popularity {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        color: #fff;
        font-size: 18px;

        .icon {
          font-size: 22px;
          line-height: 28px;
          margin-right: 9px;
        }

        .item .hint-box,
        .item .right {
          width: 116px;
        }

        .time-box {
          display: flex;
          justify-content: space-between;
          width: 80%;
          .item {
            display: flex;
            .time {
              margin-top: 10px;
              color: #ff3e6c;
            }
            .not-start-time {
              color: #fff;
            }
          }
        }

        .popularity {
          display: flex;
          width: 80%;
          .right-popularity {
            flex: 1;
            .info-list {
              margin-top: 20px;
              .item {
                display: flex;
                justify-content: space-between;
                font-size: 16px;
                margin-bottom: 25px;
                .num-box {
                  display: flex;
                  align-items: center;
                  margin-top: 10px;
                  font-size: 24px;
                  color: #4b45ff;
                  .rise,
                  .go-down {
                    margin-left: 15px;
                    font-size: 25px;
                    color: #ff3e6c;
                  }
                  .go-down {
                    color: #12c1c1;
                  }
                }
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }

      .bullet-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        color: #fff;
        padding: 20px 0;
        .title-box {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          padding-left: 20px;
          font-size: 18px;
          .decorate {
            width: 31px;
            height: 11px;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
        .content {
          flex: 1;
          overflow: hidden;
          .list {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            .container {
              box-sizing: border-box;
              width: 75%;
              overflow: hidden;
            }
            .item {
              box-sizing: border-box;
              display: flex;
              width: fit-content;
              padding-right: 10px;
              margin-bottom: 15px;
              font-size: 16px;
              color: #fff;
              background-color: rgba(0, 0, 0, 0.3);
              border-radius: 15px;
              .avatar-box {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                margin-right: 9px;
                border-radius: 50%;
                overflow: hidden;
                background-color: #fff;
                vertical-align: middle;
                .avatar-img {
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  vertical-align: middle;
                }
              }
              .desc {
                flex: 1;
                overflow: hidden;
                line-height: 27px;
                word-break: break-all;
                .username {
                  color: #4b45ff;
                }
              }
            }
          }
        }
      }
      ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-right: 0px !important;
        margin-bottom: 0px !important;

        &::-webkit-scrollbar {
          display: none !important;
        }
      }
    }
  }
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
